module.exports = __webpack_public_path__ + "img/pairG-1.fa470dfa.png";